interface Props {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  suffix?: string;
  compact?: boolean;
  accentColor?: string;
}

export function NumberInput({
  label,
  value,
  onChange,
  min = 0,
  max,
  step = 1,
  suffix,
  compact = false,
  accentColor,
}: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = parseFloat(e.target.value);
    if (!isNaN(val)) {
      onChange(val);
    }
  };

  if (compact) {
    return (
      <div
        className="flex items-center gap-2 bg-white/50 rounded-lg p-1.5"
        style={accentColor ? { borderLeft: `3px solid ${accentColor}` } : undefined}
      >
        <label className="text-xs font-medium text-spi-slate w-20 flex-shrink-0">{label}</label>
        <div className="relative flex-1">
          <input
            type="number"
            value={value}
            onChange={handleChange}
            min={min}
            max={max}
            step={step}
            className="input text-sm py-1.5 pr-14"
          />
          {suffix && (
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-spi-slate font-medium">
              {suffix}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <label className="input-label">{label}</label>
      <div className="relative">
        <input
          type="number"
          value={value}
          onChange={handleChange}
          min={min}
          max={max}
          step={step}
          className="input pr-20"
        />
        {suffix && (
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-spi-slate font-medium">
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
}
